<article class="bg-primary-900 flex flex-col items-center gap-3 rounded-xl p-4 text-center">
  <div class="relative">
    <image
      class="size-40"
      [class.opacity-50]="!badge().achieved"
      [url]="badge().image"
      [alt]="badge().name"
      [showBorder]="true" />

    @if (!badge().achieved) {
    <img
      class="absolute top-1/2 left-1/2 z-20 size-16 -translate-x-1/2 -translate-y-1/2"
      src="https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/sala_de_trofeos/lock.png"
      alt="Insignia bloqueada" />
    }
  </div>

  <h4
    class="preset-title-2 font-bold text-white uppercase"
    data-test="badge-name"
    [class.opacity-50]="!badge().achieved">
    {{ badge().name }}
  </h4>

  <button
    data-test="open-button"
    class="text-primary-900 bg-accent-900 preset-title-4 md:preset-title-3 shadow-button-inset disabled:bg-accent-900/50 w-full grow cursor-pointer rounded-3xl px-3 py-1 disabled:cursor-not-allowed"
    (click)="openModal()">
    Ver más
  </button>
</article>
